/* ----- code generated do not modify ----- */
var components_combo_box_locale23 = {
  "buttonLabel": "Mostrar sugest\xF5es",
  "countAnnouncement": function countAnnouncement(args, formatter) {
    return "".concat(formatter.plural(args.optionCount, {
      one: function one() {
        return "".concat(formatter.number(args.optionCount), " op\xE7\xE3o");
      },
      other: function other() {
        return "".concat(formatter.number(args.optionCount), " op\xE7\xF5es");
      }
    }), " dispon\xEDvel.");
  },
  "focusAnnouncement": function focusAnnouncement(args, formatter) {
    return "".concat(formatter.select({
      "true": function _true() {
        return "Grupo inserido ".concat(args.groupTitle, ", com ").concat(formatter.plural(args.groupCount, {
          one: function one() {
            return "".concat(formatter.number(args.groupCount), " op\xE7\xE3o");
          },
          other: function other() {
            return "".concat(formatter.number(args.groupCount), " op\xE7\xF5es");
          }
        }), ". ");
      },
      other: ""
    }, args.isGroupChange)).concat(args.optionText).concat(formatter.select({
      "true": ", selecionado",
      other: ""
    }, args.isSelected));
  },
  "listboxLabel": "Sugest\xF5es",
  "selectedAnnouncement": function selectedAnnouncement(args) {
    return "".concat(args.optionText, ", selecionado");
  }
};

export { components_combo_box_locale23 as default };
//# sourceMappingURL=pt-BR.esm.js.map
